exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-body .btn[data-v-51bc9cc4] {\n  position: relative;\n  padding-right: 20px;\n}\n.card-body .btn i.mdi[data-v-51bc9cc4] {\n  top: 4px;\n  right: 3px;\n  position: absolute;\n}", ""]);

// exports
